
let loadPromise: Promise<void> | null = null;

/**
 * Dynamically loads the Google Maps JavaScript API with Places library.
 * Forces language to English for database normalization.
 */
export const loadGoogleMaps = (apiKey: string): Promise<void> => {
    if (loadPromise) return loadPromise;

    loadPromise = new Promise((resolve, reject) => {
        if ((window as any).google && (window as any).google.maps) {
            resolve();
            return;
        }

        const script = document.createElement('script');
        // language=en ensures we get "Rome, Italy" instead of "Roma, Italia"
        script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAf6vSciBIYbPxqXJf3KFYY_PPpB9-986s&libraries=places&language=en`;
        script.async = true;
        script.defer = true;
        script.onload = () => resolve();
        script.onerror = (err) => {
            loadPromise = null;
            reject(err);
        };
        document.head.appendChild(script);
    });

    return loadPromise;
};
